<template>
  <section class="view-parent">
    <header class="product-header-parent">
      <p class="product-header p-tag">{{ name }}</p>
    </header>
    <div ref="productPlaceholder" class="product-parent-placeholder">
      <div ref="imgBox" class="product-placeholder">
        <i v-show="loading" class="icon loading loading-pos"></i>
        <transition appear name="fade-long">
          <img
            ref="productFamily"
            alt="products"
            class="product-image-element"
            :src="require(`@/assets/productpage/segments/${familyImagePath}`)"
            @load="picLoaded"
          />
        </transition>
      </div>
    </div>
    <div ref="productFamilyFooter" class="bottom-escape">
      <div class="bottom-inner" @click="goBack($event)">
        <img class="icon-general" src="../assets/eds-icons/arrow-left.svg" />
      </div>
    </div>
  </section>
</template>

<script>
import ProductApiService from '@/services/productApiService';
export default {
  props: ['familyImagePath', 'name'],
  data() {
    return {
      loading: true
    };
  },
  async mounted() {
    await ProductApiService.getProductFamilies();
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    picLoaded() {
      this.loading = false;
    }
  }
};
</script>

<style lang="less" scoped>
@import '~@eds/vanilla/variables/dark.less';
@import '~@eds/vanilla/variables/global.less';
.product-header-parent {
  position: fixed;
  top: 0;
  left: 0;
  padding: @space-large;
}
.product-placeholder {
  position: relative;
  display: block;
  margin: 0px auto;
  width: 90%;
}
.product-image-element {
  display: block;
  width: 100%;
  object-fit: contain;
}
.view-parent {
  position: relative;
  padding: @space-large;
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
/*  FOOTER */
.bottom-escape {
  position: fixed;
  bottom: 0;
  left: 0;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding-left: @space-xl;
  padding-right: @space-xl;
  padding-bottom: @space-large;
}
/* Loading */
.loading-pos {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
</style>
